import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Box,
  Grid,
  Stack,
  Divider,
  Tabs,
  Tab,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import StarIcon from "@mui/icons-material/Star";
import FiveSlotSymbolIcon from "./FiveSlotSymbolIcon";
import {
  FIAT_SET_SYMBOLS,
  CRYPTO_SET_SYMBOLS,
  JACKPOT_DEFAULTS,
} from "./fiveSlotConfig";
import { DEFAULT_CURRENCY } from "../../../../../static/Constants";

export const FiveSlotPaytableModal = ({
  open,
  onClose,
  activeCategory = "fiat",
  currency = DEFAULT_CURRENCY,
}) => {
  const [selectedTab, setSelectedTab] = useState(activeCategory === "crypto" ? "crypto" : "fiat");

  const currentSymbols = selectedTab === "crypto" ? CRYPTO_SET_SYMBOLS : FIAT_SET_SYMBOLS;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "20px",
          background: "linear-gradient(180deg, #090e17 0%, #0f172a 100%)",
          border: "2px solid #eab308",
          boxShadow: "0 0 40px rgba(234, 179, 8, 0.35)",
          color: "#ffffff",
          p: { xs: 1, sm: 2 },
          maxHeight: "90vh",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: "1px solid rgba(234, 179, 8, 0.3)",
          pb: 1.5,
        }}
      >
        <Stack direction="row" alignItems="center" spacing={1.5}>
          <Box
            sx={{
              p: "6px",
              borderRadius: "8px",
              background: "linear-gradient(135deg, #f59e0b, #d97706)",
              display: "flex",
            }}
          >
            <EmojiEventsIcon sx={{ color: "#ffffff", fontSize: 24 }} />
          </Box>
          <Box>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 900,
                color: "#fef08a",
                letterSpacing: "1px",
                textTransform: "uppercase",
                lineHeight: 1.2,
              }}
            >
              PAYTABLE & WINNING LOGIC (5 REELS)
            </Typography>
            <Typography variant="caption" sx={{ color: "#94a3b8" }}>
              5-Reel Progressive Pokies • Center Payline • 5-Symbol Editions
            </Typography>
          </Box>
        </Stack>
        <IconButton onClick={onClose} sx={{ color: "#94a3b8", "&:hover": { color: "#ffffff" } }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ mt: 2, px: { xs: 1, sm: 2 } }}>
        {/* TAB SELECTOR: FIAT VS CRYPTO */}
        <Box sx={{ mb: 2.5, display: "flex", justifyContent: "center" }}>
          <Tabs
            value={selectedTab}
            onChange={(e, val) => setSelectedTab(val)}
            sx={{
              bgcolor: "rgba(15, 23, 42, 0.8)",
              p: "4px",
              borderRadius: "14px",
              border: "1px solid rgba(234, 179, 8, 0.4)",
              "& .MuiTabs-indicator": { display: "none" },
            }}
          >
            <Tab
              value="fiat"
              label="Fiat 5-Reel Symbols"
              sx={{
                color: selectedTab === "fiat" ? "#451a03 !important" : "#94a3b8",
                bgcolor:
                  selectedTab === "fiat"
                    ? "linear-gradient(180deg, #fef08a 0%, #eab308 100%) !important"
                    : "transparent",
                background:
                  selectedTab === "fiat"
                    ? "linear-gradient(180deg, #fef08a 0%, #eab308 100%)"
                    : "transparent",
                borderRadius: "10px",
                fontWeight: 900,
                fontSize: "0.85rem",
                textTransform: "none",
                minHeight: "36px",
                px: 2.5,
              }}
            />
            <Tab
              value="crypto"
              label="Crypto 5-Reel Symbols"
              sx={{
                color: selectedTab === "crypto" ? "#451a03 !important" : "#94a3b8",
                bgcolor:
                  selectedTab === "crypto"
                    ? "linear-gradient(180deg, #fef08a 0%, #eab308 100%) !important"
                    : "transparent",
                background:
                  selectedTab === "crypto"
                    ? "linear-gradient(180deg, #fef08a 0%, #eab308 100%)"
                    : "transparent",
                borderRadius: "10px",
                fontWeight: 900,
                fontSize: "0.85rem",
                textTransform: "none",
                minHeight: "36px",
                px: 2.5,
              }}
            />
          </Tabs>
        </Box>

        {/* PROGRESSIVE JACKPOT TIERS */}
        <Box sx={{ mb: 3 }}>
          <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1.5 }}>
            <StarIcon sx={{ color: "#f59e0b", fontSize: 20 }} />
            <Typography variant="subtitle2" sx={{ fontWeight: 800, color: "#fde047" }}>
              PROGRESSIVE JACKPOT POOLS (5-OF-A-KIND)
            </Typography>
          </Stack>
          <Grid container spacing={1.5}>
            <Grid item xs={12} sm={4}>
              <Box
                sx={{
                  p: 1.5,
                  borderRadius: "12px",
                  background: "linear-gradient(180deg, rgba(239, 68, 68, 0.25) 0%, rgba(153, 27, 27, 0.45) 100%)",
                  border: "1.5px solid #ef4444",
                  textAlign: "center",
                }}
              >
                <Typography variant="caption" sx={{ color: "#fca5a5", fontWeight: 800, display: "block" }}>
                  👑 MEGA JACKPOT
                </Typography>
                <Typography variant="h6" sx={{ fontWeight: 900, color: "#fef08a" }}>
                  {currency} {JACKPOT_DEFAULTS.mega.toLocaleString()}
                </Typography>
                <Typography variant="caption" sx={{ color: "#cbd5e1", fontSize: "0.7rem" }}>
                  5x {selectedTab === "crypto" ? "Bitcoin (BTC)" : "Royal Crown"}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box
                sx={{
                  p: 1.5,
                  borderRadius: "12px",
                  background: "linear-gradient(180deg, rgba(168, 85, 247, 0.25) 0%, rgba(107, 33, 168, 0.45) 100%)",
                  border: "1.5px solid #c084fc",
                  textAlign: "center",
                }}
              >
                <Typography variant="caption" sx={{ color: "#e9d5ff", fontWeight: 800, display: "block" }}>
                  💎 MAJOR JACKPOT
                </Typography>
                <Typography variant="h6" sx={{ fontWeight: 900, color: "#fef08a" }}>
                  {currency} {JACKPOT_DEFAULTS.major.toLocaleString()}
                </Typography>
                <Typography variant="caption" sx={{ color: "#cbd5e1", fontSize: "0.7rem" }}>
                  5x {selectedTab === "crypto" ? "Diamond" : "Gold Nugget"}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box
                sx={{
                  p: 1.5,
                  borderRadius: "12px",
                  background: "linear-gradient(180deg, rgba(34, 197, 94, 0.25) 0%, rgba(21, 128, 61, 0.45) 100%)",
                  border: "1.5px solid #4ade80",
                  textAlign: "center",
                }}
              >
                <Typography variant="caption" sx={{ color: "#bbf7d0", fontWeight: 800, display: "block" }}>
                  🍒 MINI JACKPOT
                </Typography>
                <Typography variant="h6" sx={{ fontWeight: 900, color: "#fef08a" }}>
                  {currency} {JACKPOT_DEFAULTS.mini.toLocaleString()}
                </Typography>
                <Typography variant="caption" sx={{ color: "#cbd5e1", fontSize: "0.7rem" }}>
                  5x {selectedTab === "crypto" ? "Polygon POL" : "Cherry"}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>

        <Divider sx={{ borderColor: "rgba(255,255,255,0.1)", my: 2.5 }} />

        {/* 5 ACTIVE SYMBOLS & PAYOUT DETAILS */}
        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 800, color: "#fde047", mb: 1.5 }}>
            5 SYMBOL WINNING TIERS (3x, 4x, 5x MATCHES)
          </Typography>
          <Grid container spacing={1.5}>
            {currentSymbols.map((sym) => (
              <Grid item xs={12} sm={6} key={sym.id}>
                <Box
                  sx={{
                    p: 1.5,
                    borderRadius: "14px",
                    background: "rgba(30, 41, 59, 0.7)",
                    border: `1.5px solid ${sym.tierColor}`,
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                    height: "100%",
                  }}
                >
                  <FiveSlotSymbolIcon symbol={sym} size="sm" />
                  <Box sx={{ flex: 1 }}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between">
                      <Typography variant="subtitle2" sx={{ fontWeight: 900, color: "#ffffff" }}>
                        {sym.label}
                      </Typography>
                      <Box
                        sx={{
                          px: 1,
                          py: "2px",
                          borderRadius: "6px",
                          bgcolor: `${sym.tierColor}33`,
                          border: `1px solid ${sym.tierColor}`,
                        }}
                      >
                        <Typography
                          variant="caption"
                          sx={{ color: sym.tierColor, fontWeight: 900, fontSize: "0.68rem" }}
                        >
                          {sym.multiplier}x Base
                        </Typography>
                      </Box>
                    </Stack>
                    <Typography variant="caption" sx={{ color: "#fde047", fontWeight: 800, display: "block" }}>
                      {sym.winOutcome || sym.winningTier}
                    </Typography>
                    <Typography variant="caption" sx={{ color: "#94a3b8", fontSize: "0.72rem", lineHeight: 1.2 }}>
                      {sym.payout}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>

        <Box
          sx={{
            mt: 2,
            p: 1.5,
            borderRadius: "10px",
            background: "rgba(234, 179, 8, 0.08)",
            border: "1px dashed rgba(234, 179, 8, 0.4)",
            textAlign: "center",
          }}
        >
          <Typography variant="caption" sx={{ color: "#fde047", fontWeight: 700 }}>
            💡 Match 3, 4, or 5 identical symbols on the center payline to trigger Progressive Jackpots or Free Spins!
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default FiveSlotPaytableModal;
